const shipperList = state => state.shipperList.data
const errorShipperList = state => state.error
const isLoadingShipperList = state => state.isLoadingShipperList

const consigneeList = state => state.consigneeList.data
const errorConsigneeList = state => state.error
const isLoadingConsigneeList = state => state.isLoadingConsigneeList

const isCreated = state => state.isCreated.data
const errorCreated = state => state.errorCreated
const isCreating = state => state.isCreating

const editAddress = state => state.editAddress.data
const isLoadingEditAddress = state => state.isLoadingEditAddress
const errorEditAddress = state => state.errorEditAddress

const dataAddressTemp = state => state.dataAddressTemp
const isLoadingDataAddress = state => state.isLoadingDataAddress

const messageDelete = state => state.messageDelete
const isLoadingDelete = state => state.isLoadingDelete
const errorDelete = state => state.errorDelete

const addressListVerivied = state => state.addressVerivied.data
const errorAddressListVerivied = state => state.errorAddressVerivied.data
const isLoadingAddressListVerivied = state => state.isLoadingAddressVerivied.data

const addressListVeriviedFilter = state => state.addressVeriviedFilter.data
const errorAddressListVeriviedFilter = state => state.errorAddressVeriviedFilter.data
const isLoadingAddressListVeriviedFilter = state => state.isLoadingAddressVeriviedFilter.data

const addressList = state => state.address.data
const errorAddressList = state => state.errorAddress.data
const isLoadingAddressList = state => state.isLoadingAddress.data

const addressListFilter = state => state.addressFilter.data
const errorAddressListFilter = state => state.errorAddressFilter.data
const isLoadingAddressListFilter = state => state.isLoadingAddressFilter.data

const addMoreAddress = state => state.addMoreAddress
const errorAddMoreAddress = state => state.errorAddMoreAddress
const isLoadingAddMoreAddress = state => state.isLoadingAddMoreAddress

const removeAddress = state => state.removeAddress
const errorRemoveAddress = state => state.errorRemoveAddress
const isLoadingRemoveAddress = state => state.isLoadingRemoveAddress

const setBillingAddress = state => state.setBillingAddress
const errorSetBillingAddress = state => state.errorSetBillingAddress
const isLoadingSetBillingAddress = state => state.isLoadingSetBillingAddress

const editMyAddress = state => state.editMyAddress
const errorEditMyAddress = state => state.errorEditMyAddress
const isLoadingEditMyAddress = state => state.isLoadingEditMyAddress

const billingAddress = state => state.billingAddress.data
const errorBillingAddress = state => state.errorBillingAddress
const isLoadingBillingAddress = state => state.isLoadingBillingAddress

const billingAddressGlobal = state => state.billingAddressGlobal
const isLoadingDataBillingGlobal = state => state.isLoadingDataBillingGlobal

export default {
  shipperList,
  errorShipperList,
  isLoadingShipperList,

  consigneeList,
  errorConsigneeList,
  isLoadingConsigneeList,

  isCreated,
  errorCreated,
  isCreating,

  editAddress,
  isLoadingEditAddress,
  errorEditAddress,

  isLoadingDataAddress,
  dataAddressTemp,

  messageDelete,
  isLoadingDelete,
  errorDelete,

  addressListVerivied,
  errorAddressListVerivied,
  isLoadingAddressListVerivied,

  addressListVeriviedFilter,
  errorAddressListVeriviedFilter,
  isLoadingAddressListVeriviedFilter,

  addressList,
  errorAddressList,
  isLoadingAddressList,

  addressListFilter,
  errorAddressListFilter,
  isLoadingAddressListFilter,

  addMoreAddress,
  errorAddMoreAddress,
  isLoadingAddMoreAddress,

  removeAddress,
  errorRemoveAddress,
  isLoadingRemoveAddress,

  setBillingAddress,
  errorSetBillingAddress,
  isLoadingSetBillingAddress,

  editMyAddress,
  errorEditMyAddress,
  isLoadingEditMyAddress,
  
  billingAddress,
  errorBillingAddress,
  isLoadingBillingAddress,

  billingAddressGlobal,
  isLoadingDataBillingGlobal
}



// WEBPACK FOOTER //
// ./src/store/modules/address/getters.js